module.exports = __webpack_public_path__ + "static/media/5.c4cf7c41.jpg";